module.exports = __webpack_public_path__ + "img/resultados-q1-2023.6f2e21a1.jpeg";